import { CiSearch } from 'react-icons/ci'
import { NavigateFunction } from 'react-router-dom'

import { PatientSurvey } from '../../api/services/surveys/types.ts'

type TableColumn = {
  header: string
  accessor: string
  render?: (data: PatientSurvey) => JSX.Element
  className?: string
  classNameTd?: string
  sorted?: boolean
}

export const setPatientSurveysTableColumns = () => {
  const columns: TableColumn[] = [
    {
      header: 'Nazwa ankiety',
      accessor: 'survey_name',
      render: (row: PatientSurvey) => (
        <p className={'text-xm'}>{row.survey_name}</p>
      ),
      className: 'w-[150px] 2xl:w-auto'
    }
  ]

  return columns
}

export const setPatientSurveysTableActions = (navigate: NavigateFunction, patientProfileId: number, patientFullName: string) => {
  return [
    {
      label: 'Wyniki',
      icon: <CiSearch className="text-lg" />,
      onClick: (row: PatientSurvey) => {
        navigate(`/patient-profile/${patientProfileId}/survey/${row.id}/`, {
          state: {
            patientFullName
          }
        })
      },
      className: 'text-blue-500 pb-1'
    }
  ]
}
